import {
	DATA_MANAGER_ADAPTERS_ADMIN,
	DATA_MANAGER_ADMIN,
} from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/data-manager-types.tsx';
import type { ObjectListViewTypes } from './types.tsx';

const GettingStartedRoles = [DATA_MANAGER_ADMIN, DATA_MANAGER_ADAPTERS_ADMIN];
const DataSourceRoles = [DATA_MANAGER_ADMIN, DATA_MANAGER_ADAPTERS_ADMIN];
const ObjectClassViewRoles = [DATA_MANAGER_ADMIN, DATA_MANAGER_ADAPTERS_ADMIN];

export const ASSETS_DATA_MANAGER_ROLES_BY_PAGE = {
	GettingStartedPage: GettingStartedRoles,
	DataSource: DataSourceRoles,
	ObjectClassView: ObjectClassViewRoles,
};

export const OBJECT_LIST_VIEW_LIST: ObjectListViewTypes = 'list';
export const OBJECT_LIST_VIEW_DATA_SOURCE_BY_DATA_SOURCE: ObjectListViewTypes =
	'data-source-by-data-source';
export const OBJECT_LIST_VIEW_ATTRIBUTE_BY_DATA_SOURCE: ObjectListViewTypes =
	'attribute-by-data-source';
